import React, { Dispatch, SetStateAction } from "react";
import FullScreenIcon from "@material-ui/icons/Fullscreen";
import FullScreenExitIcon from "@material-ui/icons/FullscreenExit";
import { isDeviceModelFishEye } from "../../../HelperCode";
import { DeviceModel } from "../../../../Models/devices";

interface Props {
  isFullScreen: boolean;
  setIsFullScreen: Dispatch<SetStateAction<boolean>>;
  buttonStyles: string;
  device?: DeviceModel;
}

const FullScreenButton = ({ isFullScreen, setIsFullScreen, buttonStyles, device }: Props) => {
  const deviceModel = device?.model;
  if (deviceModel && isDeviceModelFishEye(deviceModel)) {
    return null;
  }
  return (
    <button
      id="fullscreen"
      className={buttonStyles}
      type="button"
      onClick={() => setIsFullScreen(!isFullScreen)}
    >
      {!isFullScreen ? <FullScreenIcon /> : <FullScreenExitIcon />}
    </button>
  );
};

export default FullScreenButton;
